// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class DeviceUnlockResource extends Resource {
    basePath: string = 'devices/unlock/';

    objectPath: string = 'devices/unlock/{ident}/';

    /**
     * The new patrol app's offline unlock code for the 6-digit request code shown on the tablet.
     *
     * @param {string} id Device uuid.
     * @param {string} requestCode The 6-digit request code.
     * @returns {Promise<Object>} `{unlock_code}`.
     */
    unlockCode(id: string, requestCode: string): Promise<Object> {
        return this.client._request(this._getObjectPath(id), 'POST', { request_code: requestCode })
            .then((response) => response.data);
    }
}
